import(/* webpackMode: "eager" */ "/home/runner/work/rocola.it/rocola.it/node_modules/next/dist/client/link.js");
